import { render, staticRenderFns } from "./RemoteManagementAndroid.vue?vue&type=template&id=4ecc767e&scoped=true&"
import script from "./RemoteManagementAndroid.vue?vue&type=script&lang=ts&"
export * from "./RemoteManagementAndroid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc767e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecc767e')) {
      api.createRecord('4ecc767e', component.options)
    } else {
      api.reload('4ecc767e', component.options)
    }
    module.hot.accept("./RemoteManagementAndroid.vue?vue&type=template&id=4ecc767e&scoped=true&", function () {
      api.rerender('4ecc767e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/rooms/RemoteManagementAndroid.vue"
export default component.exports